'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardRest = function () {
  function DashboardRest($http) {
    (0, _classCallCheck3.default)(this, DashboardRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      DEFAULT: 'default-dashboards/',
      LIST: 'dashboards/',
      DETAIL: 'dashboards/%1$s/',
      DEFAULT_DETAIL: 'default-dashboards/%1$s/'
    };
  }

  (0, _createClass3.default)(DashboardRest, [{
    key: 'create',
    value: function create(postData) {
      return this.$http.post(this.PATH.LIST, postData);
    }
  }, {
    key: 'update',
    value: function update(id, postData) {
      return this.$http.patch(this.sprintf(this.PATH.DETAIL, id), postData);
    }
  }, {
    key: 'save',
    value: function save(postData) {
      return postData.id ? this.update(postData.id, postData) : this.create(postData);
    }
  }, {
    key: 'getList',
    value: function getList(params) {
      return this.$http.get(this.PATH.LIST, { params: params });
    }
  }, {
    key: 'read',
    value: function read(id) {
      return this.$http.get(this.sprintf(this.PATH.DETAIL, id));
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      return this.$http.delete(this.sprintf(this.PATH.DETAIL, id));
    }
  }, {
    key: 'getDefaultDashboard',
    value: function getDefaultDashboard(key, params) {
      return this.$http.get(this.sprintf(this.PATH.DEFAULT_DETAIL, key), { params: params });
    }
  }]);
  return DashboardRest;
}();

exports.default = DashboardRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/DashboardResource.js
// module id = 307
// module chunks = 0